import { call, put, takeLatest } from 'redux-saga/effects';

import * as url from '../../helpers/url_helper';

// Crypto Redux States
import { cargoReleaseTypes } from './actionTypes';
import { getCargoReleaseList, getCargoReleaseListFail, getCargoReleaseListSuccess, getMilestoneConfigCRFail, getMilestoneConfigCRSuccess } from './actions';
import { getMilestoneConfigOperation } from '../../helpers/GetMilestoneConfigOperation';

let controller = new AbortController();
let signal = controller.signal;

export const cancelFetchCR = () => {
  controller.abort(); // Esto cancelará la solicitud
  controller = new AbortController(); // Restablecer el controlador para futuras solicitudes
  signal = controller.signal; // Actualizar la señal para futuras solicitudes
};


export const fetchList = async (data: any) => {
    const { from, to, order, dynamicFilter, dynamicFilterCF } = data.form;
    const { sizePerPage, page } = data.pagination;

    const path = url.API_URL;
    const getAuthUser = localStorage.getItem('authUser');
    let user;
    if (getAuthUser) {
        user = JSON.parse(getAuthUser);
    }

    const query = `query {
    GetCargoRelease(CargoReleases: {
        userId: ${user.id || ''},
        initial_date: "${from || ''}",
        final_date: "${to + ' 11:59:00' || ''}",
        order : "${order}",
        ${dynamicFilterCF}
        ${dynamicFilter}
      }, Pagination:{
        sizePage:${sizePerPage},
        actualPage:${page}
      })
      {
        cargoReleasesData{
          id
          clientId
          CreatedOn
          ReleaseDate
          Number
          CreatedByName
          Version    
          IssuedByName    
          CreatorNetworkID
          TotalPieces
          TotalWeight
          TotalVolume
          TotalVolumeWeight    
          TotalValue
          ReleasedToName
          Status
          HasAttachments    
          IsOnline
          IsLiquidated    
          CFaverage_days_to_prepare
          CFaverage_days_to_release
          CFwh_location
          CFcr_cartons
          CFcr_pallets
          AreaPrecision
          CargoStorageID
          DbClassType
          IsOnlineTransaction
          IsTrackingEmailSent
          LengthPrecision
          LengthUnit
          VolumePrecision
          VolumeUnit
          VolumeWeightPrecision
          WeightPrecision
          WeightUnit
          VolumeWeightUnit
          Barcodes       
          CarrierName       
          CarrierPRONumber
          CarrierTrackingNumber
          DocumentTemplateName
          DriverLicenseNumber
          DriverName 
          Notes
          SupplierPONumber 

          GUID
          customFields {
            name
            value
            internalName
          }
        } 
        CountItems       
    }
  }`;

    const response = await fetch(path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            query,
        }),
        signal
    }).then((res) => res.json());

    return response.data.GetCargoRelease;
};

function* fetchListSaga(data: any) {
    try {
        const response: Promise<any> = yield call(fetchList, data.payload);
        yield put(getCargoReleaseListSuccess(response));
    } catch (error) {
        yield put(getCargoReleaseListFail(error));
    }
}

function* getMilestoneConfigCR(data: any): any {
  try {
    const response: Promise<any> = yield call(getMilestoneConfigOperation, "CR");
    yield put(getMilestoneConfigCRSuccess(response));
  } catch (error) {
    yield put(getMilestoneConfigCRFail(error));
  }
}

function* cargoReleaseSaga() {
    yield takeLatest(cargoReleaseTypes.GET_CARGORELEASE, fetchListSaga);
    yield takeLatest(cargoReleaseTypes.GET_MILESTONESCONFIG_CR, getMilestoneConfigCR)
}

export default cargoReleaseSaga;
